/*eslint-disable*/
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  namespaced: true,
  state: {
    userinfo: {},
    showDataImgs:{},
    searchObj:{},
    addForestEvaluate:{},
    ForestEvaluateReload:"",//刷新评价列表
    addCommontType:{},//添加评论弹框
    callBackCommontType:"",//点击保存回调
    closeShowType:'',
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userinfo = userInfo;
    },
    setDataImgs(state,DataImgs){
      state.showDataImgs = DataImgs;
    },
    setSearchObj(state,searchObj){
      state.searchObj = searchObj;
    },
    setForestEvaluateObj(state,addForestEvaluate){
      state.addForestEvaluate = addForestEvaluate;
    },
    setForestEvaluateReload(state,ForestEvaluateReload){
      state.ForestEvaluateReload = ForestEvaluateReload;
    },
    setAddCommontType(state,addCommonType){
      state.addCommontType = addCommonType;
    },
    setCallBackCommont(state,callBackType){
      state.callBackCommontType = callBackType;
    },
    SetcloseShowType(state,closeShowType){
      state.closeShowType = closeShowType;
    }
  },
  actions: {}
})